
import "./FinishSteps.js"
import "./DateUtility.js"
import "./Steps/InstructionStep.js"
import "./Steps/CaptureStep.js"
import "./Steps/CompletionStep.js"
import "./Steps/ConsentReviewStep.js"
import "./Steps/CountdownStep.js"
import "./Steps/FormStep.js"
import "./Steps/QuestionStep.js"
import "./Steps/VideoInstructionStep.js"
import "./Steps/VisualConsentStep.js"
import "./Steps/WaitStep.js"
import "./Steps/WebViewStep.js"
import moment from 'moment-timezone';
import * as cloneDeep from 'lodash/cloneDeep'
import { getProgressIndicatorType, getFormStyle, getBackgroundStyles, getTextStyles, getNextButtonStyles, getIconImageStyles, getContentItemSettings } from "../../components/Survey/Util/surveyStyles"

function StepManager(step, surveyManager) {
	this.step = step;
	this.surveyManager = surveyManager;
	this.presentedDate = moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ');
	this.dismissedDate = null;
	this.childResults = [];
	this.documents = [];
}

StepManager.prototype.initializeResults = function (previousResult) {
	if (previousResult && previousResult.QuestionResults) {
		// use lodash cloneDeep instead of angular.copy, because angular.copy doesn't handle File objects correctly
		this.childResults = cloneDeep(previousResult.QuestionResults);
		for (var i = 0; i < this.childResults.length; i++) {
			this.childResults[i].StartDate = this.presentedDate;
		}
	}
}

StepManager.prototype.getNextButtonStyles = function () {
	return getNextButtonStyles(this.surveyManager.template, this.step);
}

StepManager.prototype.getBackgroundStyles = function () {
	return getBackgroundStyles(this.surveyManager.template, this.step);
}

StepManager.prototype.getFormStyle = function () {
	return getFormStyle(this.surveyManager.template, this.step);
}

StepManager.prototype.getTextStyles = function (element) {
	return getTextStyles(element, this.surveyManager.template, this.step);
}

StepManager.prototype.getIconImageStyles = function () {
	return getIconImageStyles(this.surveyManager.template, this.step);
}

StepManager.prototype.getContentItemSettings = function() {
	return getContentItemSettings(this.surveyManager.template, this.step);
}


StepManager.prototype.getResult = function () {
	//this is a difference from the ResearchKit iOS behavior
	//in ResearchKit iOS, each step is responsible for setting end dates of it's child results
	//in particular, a form step's question result end dates will be the date when the control was blurred
	//however, the below is much simpler
	for (var i = 0; i < this.childResults.length; i++) {
		this.childResults[i].EndDate = this.dismissedDate;
	}
	var visibleResults = _.reject(this.childResults, function (result) { return result.hidden; });
	return { Identifier: this.step.identifier, StartDate: this.presentedDate, EndDate: this.dismissedDate, QuestionResults: visibleResults, Documents: this.documents };
}

StepManager.prototype.getChildResult = function (identifier) {
	return _.find(this.childResults, function (result) { return result.Identifier.toLowerCase() == identifier.toLowerCase() });
}

StepManager.prototype.setChildResult = function (identifier, result) {
	var index = _.findIndex(this.childResults, function (result) { return result.Identifier.toLowerCase() == identifier.toLowerCase() });
	if (index != -1) {
		// This is a hack to fix casing changes on restored results from Coordinator Surveys.
		result.Identifier = identifier;
		this.childResults[index] = result;
	}
}

StepManager.prototype.continue = function () {
	this.surveyManager.setManagedResult(this.getResult(), this.step.identifier);
	if (!this.surveyManager.stepCanContinue(this)) {
		return false;
	}

	this.dismissedDate = moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ');
	this.surveyManager.setManagedResult(this.getResult(), this.step.identifier);
	this.surveyManager.stepDidFinish(this, true);
	return true;
}

StepManager.prototype.skip = function () {
	for (var i = 0; i < this.childResults.length; i++) {
		delete this.childResults[i]["Answer"];
		delete this.childResults[i]["Choices"];
		delete this.childResults[i]["invalid"];
		delete this.childResults[i]["File"];
		delete this.childResults[i]["FileName"];
		delete this.childResults[i]["StorageLocation"];
		delete this.childResults[i]["ContentType"];
		delete this.childResults[i]["Modified"];
	}
	this.dismissedDate = moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ');
	this.surveyManager.setManagedResult(this.getResult(), this.step.identifier);
	if (!this.surveyManager.stepCanContinue(this)) {
		//re-initialize results since we can't continue
		this.initializeResults();
		return;
	}
	this.surveyManager.stepDidFinish(this, true);
}

StepManager.prototype.back = function () {
	this.surveyManager.stepDidFinish(this, false);
}

StepManager.prototype.closeSurvey = function () {
	this.surveyManager.promptForSurveyClose();
}

StepManager.prototype.showSaveAndClose = function () {
	return !this.step.saveOnArrival && this.surveyManager.showSaveAndClose();
}

StepManager.prototype.saveAndCloseSurvey = function () {
	this.surveyManager.saveAndClose();
}

StepManager.prototype.isLastStep = function () {
	if (this.step.saveOnArrival) {
		return true;
	}

	var nextStep = this.surveyManager.nextStep();
	if (nextStep && !this.surveyManager.getFinishStep(nextStep.identifier)) {
		return false;
	}
	return true;
}

StepManager.prototype.canGoBack = function () {
	if (this.step.saveOnArrival) {
		return false;
	}

	if (this.surveyManager.editMode) {
		return this.surveyManager.template.steps.indexOf(this.step) != 0;
	}

	if (this.surveyManager.previousStep()) {
		return true;
	}
	return false;
}

StepManager.prototype.totalSteps = function () {
	return this.surveyManager.template.steps.length;
}

StepManager.prototype.stepIndex = function () {
	return getStepIndex(this.surveyManager.template, this.step.identifier);
}

StepManager.prototype.resultDidChange = function () {
	this.surveyManager.setManagedResult(this.getResult(), this.step.identifier);
}

StepManager.prototype.showCancelButton = function () {
	return !this.step.saveOnArrival && this.surveyManager.template.cancelButtonLabel !== '';
}

StepManager.prototype.showStepHeader = function () {
	return this.canGoBack() || getProgressIndicatorType(this.surveyManager.template, this.step) || this.showSaveAndClose() || this.showCancelButton();
}

function getStepIndex(template, identifier) {
	return _.findIndex(template.steps, function (step) { return step.identifier == identifier; });
}

angular.module('ResearchKitApplicationModule').service('StepManager', function () {
	return StepManager;
});

angular.module('ResearchKitApplicationModule').service('stepManagerFactory', [
	'StepManager',
	'InstructionStepManager',
	'QuestionStepManager',
	'FormStepManager',
	'ConsentReviewStepManager',
	'VisualConsentStepManager',
	'WaitStepManager',
	'ImageCaptureStepManager',
	'ConsentFormStepManager',
	function (StepManager, InstructionStepManager, QuestionStepManager, FormStepManager, ConsentReviewStepManager, VisualConsentStepManager, WaitStepManager, ImageCaptureStepManager, ConsentFormStepManager) {
		this.createStepManager = function (step, surveyManager) {
			switch (step.type) {
				case 'InstructionStep':
					return new InstructionStepManager(step, surveyManager);
				case 'QuestionStep':
					return new QuestionStepManager(step, surveyManager);
				case 'FormStep':
					return new FormStepManager(step, surveyManager);
				case 'ConsentReviewStep':
					return new ConsentReviewStepManager(step, surveyManager);
				case 'VisualConsentStep':
					return new VisualConsentStepManager(step, surveyManager);
				case 'WaitStep':
					return new WaitStepManager(step, surveyManager);
				case 'ImageCaptureStep':
					return new ImageCaptureStepManager(step, surveyManager);
				case 'ConsentStep':
					return new ConsentReviewStepManager(step, surveyManager);
				case 'ConsentFormStep':
					return new ConsentFormStepManager(step, surveyManager);
				case 'EndOfSurveyStep':
					var endOfSurveyStep = Object.assign({}, step, step.renderStep);
					endOfSurveyStep.identifier = step.identifier;
					endOfSurveyStep.saveOnArrival = true;
					return this.createStepManager(endOfSurveyStep, surveyManager);
			}
			return new StepManager(step, surveyManager);
		}
	}
]);